import React, { Component } from "react";
import { withRouter, Link } from "react-router-dom";
import Util from "../../Util";
class TableNavContratados extends Component {
  render() {
    var tableHeaders = [
      "CPF/CNPJ",
      "Nome/Razão social",
      "Telefone",
      "Endereço",
      "Valores contratados",
      "Ações",
    ];
    return (
      <table className="table table-hover">
        <thead className="text-warning">
          <tr>
            {tableHeaders.map((header, key) => {
              return <th key={key}>{header}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {this.props.rows.map((row, key) => {
            return (
              <tr key={key}>
                <td className="col-md-2">
                  {Util.getMaskedCPFCNPJ(row.cpf_cnpj)}
                </td>
                <td className="col-sm-4">{row.nome_razao_social}</td>
                <td className="col-sm-2">
                  {Util.getMaskedPhone(row.telefone)}
                </td>
                <td className="col-sm-4">
                  {row.rua +
                    ", " +
                    row.numero +
                    ", " +
                    row.bairro +
                    ", " +
                    row.cidade +
                    ", " +
                    row.estado}
                </td>
                <td className="col-sm-1">
                  {Util.formatCurrency(parseFloat(row.valores_contratados))}
                </td>
                <td className="td-actions text-right">
                  <Link
                    title="Editar contratado"
                    className="btn btn-primary btn-simple btn-xs"
                    to={"contratados/edit/" + row.id}
                  >
                    <i className="material-icons">edit</i>
                  </Link>
                  <Link
                    title="Ir para a tela de contratados"
                    className="btn btn-primary btn-simple btn-xs"
                    to={"contratados/"}
                  >
                    <i className="material-icons">forward</i>
                  </Link>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }
}
export default withRouter(TableNavContratados);



// WEBPACK FOOTER //
// ./src/views/contratados/TableNavContratados.js